/**
 * Plugin contexts:
 * https://github.com/thysultan/stylis.js/blob/4561e9bc830fccf1cb0e9e9838488b4d1d5cebf5/stylis.js#L150
 */
export var STYLIS_CONTEXTS = {
  AT_RULE: 3,
  NEWLINE: 0,
  POST_PROCESS: -2,
  PREPARATION: -1,
  PROPERTY: 1,
  SELECTOR_BLOCK: 2
};
/**
 * Character codes and special identifiers:
 * https://github.com/thysultan/stylis.js/blob/4561e9bc830fccf1cb0e9e9838488b4d1d5cebf5/stylis.js#L92
 */

export var STYLIS_TOKENS = {
  KEYFRAME: 107
};